import React, {useEffect} from 'react'
import { useStore, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MainComponent from "./main/index"
import HomeSkeleton from "./skeleton/index"
import { BlackMask } from "../../../../components/mask/index"
import { useState } from 'react'

const Home = props => {
    useStyles(classes);
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const { customer } = useSelector(state => state.pageCustomer);
    const [loading, setLoading] = useState(false);
    const [showSkeleton, setShowSkeleton] = useState(false);

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await Home.fetchData(store, params, query)
		}
    }, []);


    return <div className={classes.MeHome}>
        <MainComponent customer={customer} setLoading={(flag)=>setLoading(flag)} />

        <div style={{display:`${loading?'block':'none'}`}} className={classes.GlobalLoading}>
            <div className={classes.LoadingItem}></div>
            <BlackMask style={{backgroundColor:`rgba(0, 0, 0, .2)`}} />
        </div>
    </div>
}


Home.fetchData = async (store, params, search, headers) => {
}

export default Home